<template>
  <div
    v-if="!isOnePlanAvailable"
    :class="[
      'shop-section-sticky-nav-bar',
      stickyBar && appReady && 'shop-section-sticky-nav-bar--z-index',
      stickyBar && isHidden && 'shop-section-sticky-nav-bar--hidden',
      stickyBar && !isHidden && 'shop-section-sticky-nav-bar--show',
      stickyBar && 'shop-section-sticky-nav-bar--sticky-bar',
    ]"
  >
    <div class="shop-section-sticky-nav-bar__wrapper">
      <SubscriptionsViewToggler v-if="displayViewToggler" />
      <ShopSectionNav :isStickyBar="stickyBar && !isHidden" :defaultPill="defaultPill" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SubscriptionsViewToggler from '@/components/flow/SubscriptionsViewToggler.vue'
import ShopSectionNav from '@/components/flow/ShopSectionNav.vue'

export default {
  name: 'ShopSectionStickyNavBar',
  components: {
    SubscriptionsViewToggler,
    ShopSectionNav,
  },
  props: {
    stickyBar: {
      type: Boolean,
      default: false,
    },
    defaultPill: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isHidden: true,
      appReady: false,
    }
  },
  computed: {
    ...mapState({
      isOnePlanAvailable: state => state.products.isOnePlanAvailable,
    }),
    ...mapGetters({
      usersCurrentSubscriptions: 'subscriptions/getUsersCurrentSubscriptions',
      isBusinessUser: 'business/isBusinessUser',
    }),
    userHasSubscription() {
      return this.usersCurrentSubscriptions.length > 0
    },
    displayViewToggler() {
      if (this.isBusinessUser) {
        return false
      }
      return !this.userHasSubscription
    },
  },
  mounted() {
    window.addEventListener('scroll', this.checkScroll)
    // needed to set isHidden initial state
    this.checkScroll()
    // This is a hack to prevent the sticky bar from showing on page load
    setTimeout(() => {
      this.appReady = true
    }, 1000)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScroll)
  },
  methods: {
    checkScroll() {
      if (this.stickyBar) {
        const shopContent = document.querySelector('.shop__content')
        if (shopContent) {
          const threshold = shopContent.offsetTop - 20
          this.isHidden = window.scrollY <= threshold
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.shop-section-sticky-nav-bar {
  $this: &;
  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: column;
    gap: 10px;
    margin-bottom: 30px;
    transition: all 0.1s ease-in-out;
    z-index: -1;
    @include tablet {
      flex-flow: row;
    }
  }
  &--z-index {
    z-index: 3;
  }
  &--hidden {
    display: none;
  }
  &--show {
    opacity: 1;
  }
  &--sticky-bar {
    position: sticky;
    top: 0;
    width: 100%;
    background: linear-gradient(180deg, #1e1e1e 71.82%, rgba(30, 30, 30, 0) 100%);
    padding-top: 10px;
    #{$this} {
      &__wrapper {
        margin: auto;
        max-width: 1120px;
      }
    }
  }
}
</style>
